import {type AssessmentDomain} from '@udemy/react-product-card-components';

const TOPIC_DOMAIN_MAP: Record<string, AssessmentDomain> = {
    '2490052': 'ai',
    '2490057': 'cloud',
    '2490049': 'software',
    '2490050': 'ops',
    '2493684': 'business',
    '2490503': 'business',
    '2493072': 'design',
    '2490502': 'cybersecurity',
    '2490040': 'software',
    '2490051': 'software',
};

const DEFAULT_DOMAIN: AssessmentDomain = 'ai';

export function getTopicDomain(topicId: string | undefined): AssessmentDomain {
    if (!topicId) return DEFAULT_DOMAIN;
    return TOPIC_DOMAIN_MAP[topicId] ?? DEFAULT_DOMAIN;
}

const CERT_DOMAINS = new Set<AssessmentDomain>(['cloud', 'cybersecurity']);
// Mirrors hasDeclaredSkillInterests: any non-certification topic interest.
const SKILL_DOMAINS = new Set<AssessmentDomain>(['ai', 'software', 'ops', 'business', 'design']);

/**
 * Topic descriptor IDs whose domain aligns with certification interests
 * (cloud certifications, cybersecurity). Derived from TOPIC_DOMAIN_MAP so
 * adding a new topic ID there automatically updates targeting here.
 */
export const CERT_DOMAIN_IDS: ReadonlySet<string> = new Set(
    Object.entries(TOPIC_DOMAIN_MAP)
        .filter(([, domain]) => CERT_DOMAINS.has(domain))
        .map(([id]) => id),
);

/**
 * Topic descriptor IDs whose domain aligns with skill interests — any non-certification
 * topic (software engineering, AI/ML, IT operations, business, design).
 * Mirrors the server-side hasDeclaredSkillInterests definition.
 * Derived from TOPIC_DOMAIN_MAP so adding a new topic ID there updates targeting automatically.
 */
export const SKILL_DOMAIN_IDS: ReadonlySet<string> = new Set(
    Object.entries(TOPIC_DOMAIN_MAP)
        .filter(([, domain]) => SKILL_DOMAINS.has(domain))
        .map(([id]) => id),
);
